// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\ntable[data-v-564aee4f] {\r\n    width: 100%;\r\n    border-collapse: collapse;\n}\nth[data-v-564aee4f], td[data-v-564aee4f] {\r\n    border: 1px solid black;\r\n    padding: 8px;\r\n    text-align: left;\r\n    width: 12.5%; /* Ensure each column takes an equal width */\n}\nul[data-v-564aee4f] {\r\n    list-style-type: none;\r\n    padding: 0;\n}\n.highlight[data-v-564aee4f] {\r\n    background-color: yellow;\r\n    transition: background-color 0.5s ease;\n}\r\n", ""]);
// Exports
module.exports = exports;
